const careerMenuItems = [
  {
    id: "available-opportunities",
    label: "Available Opportunities",
    path: "/career/available-opportunities",
  },
  {
    id: "updates",
    label: "Updates",
    path: "/career/updates",
  },
  {
    id: "archive-opportunities",
    label: "Archive Opportunities",
    path: "/career/archive-opportunities",
  },
  {
    id: "nmdfc-internship-scheme",
    label: "NMDFC Internship Scheme",
    path: "/career/nmdfc-internship-scheme",
  },
  {
    id: "active-tenders",
    label: "Active Tenders",
    path: "/career/active-tenders",
  },
  {
    id: "archive-tenders",
    label: "Archive Tenders",
    path: "/career/archive-tenders",
  },
];

export const normalizeCareerSection = (section) => {
  const matchedSection = careerMenuItems.find((item) => item.id === section);
  return matchedSection ? matchedSection.id : careerMenuItems[0].id;
};

export const getCareerSection = (section) =>
  careerMenuItems.find((item) => item.id === section) || careerMenuItems[0];

export default careerMenuItems;
